import React from 'react';

import { BaseIconProps } from './';

export const StarHalf = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.1906694,0,0,-2.1906694,0,1088.7627)"
    d="M 260,497 187,325 0,309 142,186 99,4 260,101 v 0 z"
    fill={fill}
  />
);
